import { c as _c } from "react/compiler-runtime";
import { Modal, PrimaryButton, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { ErrorResponseContentInterface } from '@systemeio/util';
import FormSenderEmailInput from 'modules/email/components/form-sender-email-input';
import { useSendTestEmail } from 'modules/mailing/hooks/use-send-test-email';
import { MailingId } from 'modules/mailing/types/mailing-interface';
import { useMailingSettings } from 'modules/profile/mailing-settings/hooks/use-mailing-settings';
import React, { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { HTMLString } from 'shared/types/html-string';
export interface SendTestEmailModalProps {
  mailingId: MailingId;
  onSave: () => Promise<void>;
  onClose: () => void;
  opened: boolean;
}
export const SendTestEmailModal = t0 => {
  const $ = _c(41);
  const {
    mailingId,
    onSave,
    onClose,
    opened
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [email, setEmail] = useState("");
  const [hasEmailBeenChanged, setHasEmailBeenChanged] = useState(false);
  const [error, setError] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const {
    fetcherSendTestEmail
  } = useSendTestEmail();
  const {
    mailingData
  } = useMailingSettings();
  let t1;
  if ($[0] !== onClose) {
    t1 = () => {
      onClose();
      setError(null);
    };
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handelClose = t1;
  let t2;
  if ($[2] !== email || $[3] !== fetcherSendTestEmail || $[4] !== mailingId || $[5] !== onClose || $[6] !== onSave) {
    t2 = async () => {
      setIsFetching(true);
      ;
      try {
        await onSave();
        await fetcherSendTestEmail(mailingId, {
          email
        });
        onClose();
      } catch (t3) {
        const e = t3;
        if (e instanceof BadRequest) {
          const errors = e.errors as ErrorResponseContentInterface<{
            email: HTMLString[];
          }>;
          if (errors?.fields?.email) {
            setError(errors.fields.email.join(""));
          }
          if (errors.common?.length) {
            toast.error(errors.common.join(""));
          }
        }
      }
      setIsFetching(false);
    };
    $[2] = email;
    $[3] = fetcherSendTestEmail;
    $[4] = mailingId;
    $[5] = onClose;
    $[6] = onSave;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleConfirm = t2;
  let t3;
  let t4;
  if ($[8] !== email || $[9] !== hasEmailBeenChanged || $[10] !== mailingData) {
    t3 = () => {
      if (!hasEmailBeenChanged && !email && mailingData) {
        setEmail(mailingData.testEmailAddress);
      }
    };
    t4 = [email, hasEmailBeenChanged, mailingData];
    $[8] = email;
    $[9] = hasEmailBeenChanged;
    $[10] = mailingData;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  useEffect(t3, t4);
  let t5;
  if ($[13] !== t) {
    t5 = t("dashboard.email.send_test_modal.title");
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = email || "";
  const t7 = !mailingData;
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e_0 => {
      setHasEmailBeenChanged(true);
      setEmail(e_0.target.value);
    };
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("dashboard.email.test_email_address");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== error || $[19] !== t6 || $[20] !== t7 || $[21] !== t9) {
    t10 = <FormSenderEmailInput value={t6} className="w-full" key="email" isPreFetching={t7} required={true} onChange={t8} htmlFor="none" label={t9} error={error} />;
    $[18] = error;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const t11 = !mailingData;
  let t12;
  if ($[23] !== handleConfirm) {
    t12 = e_1 => {
      e_1.preventDefault();
      handleConfirm();
    };
    $[23] = handleConfirm;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("global.confirm");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isFetching || $[28] !== t11 || $[29] !== t12 || $[30] !== t13) {
    t14 = <div className="flex justify-center"><PrimaryButton isFetching={isFetching} disabled={t11} width="large" onClick={t12} type="submit">{t13}</PrimaryButton></div>;
    $[27] = isFetching;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t10 || $[33] !== t14) {
    t15 = <form className="m-auto flex w-full flex-col gap-6 lg:gap-10">{t10}{t14}</form>;
    $[32] = t10;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== handelClose || $[36] !== isFetching || $[37] !== opened || $[38] !== t15 || $[39] !== t5) {
    t16 = <Modal isFetching={isFetching} isCentered={true} opened={opened} onClose={handelClose} title={t5}>{t15}</Modal>;
    $[35] = handelClose;
    $[36] = isFetching;
    $[37] = opened;
    $[38] = t15;
    $[39] = t5;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};